var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { GatewayCard } from '../general';
import { getExchangeOidcToken } from '@sonar-software/sonar-security';
import { LoadingSpinner } from '@ui/LoadingSpinner';
import { useOnMount } from '@hooks';
import { FULL_ROUTES, INTEGRATIONS_COPY } from '@sonar-software/sonar-ts-constants';
import { getIdTokenQuery, getQueryStringParameter, removeJWTToken, setJWTToken } from '@sonar-software/sonar-ts-lib';
import React, { useState } from 'react';
function exchangeOIDCToken(originalToken) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a;
        setJWTToken(originalToken);
        try {
            const response = yield getExchangeOidcToken();
            if ((_a = response.data) === null || _a === void 0 ? void 0 : _a.localUserIdToken) {
                setJWTToken(response.data.localUserIdToken);
                const extension = getQueryStringParameter(window.location.search, 'extension');
                window.location.replace(`${FULL_ROUTES.ONBOARDING_CONNECT}${extension ? 'extension=true' : ''}`);
            }
            else {
                throw new Error('Unable to exchange OIDC token.');
            }
        }
        catch (ex) {
            removeJWTToken();
        }
    });
}
export const OIDCIntegration = () => {
    const [errorDescription, setErrorDescription] = useState();
    useOnMount(() => {
        const idToken = getIdTokenQuery(window.location.hash);
        const error = getQueryStringParameter(window.location.hash.slice(1), 'error_description');
        if (error) {
            setErrorDescription(error);
        }
        exchangeOIDCToken(idToken);
    });
    return (React.createElement(GatewayCard, { title: errorDescription !== null && errorDescription !== void 0 ? errorDescription : INTEGRATIONS_COPY.OIDC_LOGIN }, errorDescription ? null : React.createElement(LoadingSpinner, { spinning: true })));
};
